import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { GoogleChartsModule } from 'angular-google-charts';
import { PressureChartConfig } from './chart-config.model';
import { csvRows, type BuildTestGraph } from '../build-test-graphs/build-test-graphs.service';

@Component({
    selector: 'lib-view-graph',
    imports: [
        GoogleChartsModule,
    ],
    templateUrl: './view-graph.component.html',
    styleUrl: './view-graph.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewGraphComponent {

  graph = input.required<BuildTestGraph>();

  chartConfig = computed(() => {
    const graph = this.graph();
    const data = csvRows(graph.csv);
    const chart = new PressureChartConfig(graph);
    // Pressure CSVs have 4 columns (time, psi, annotation, emphasis); force CSVs add a force column.
    chart.setData(data[0]?.length === 4 ? 'psi' : 'force', data);
    return chart;
  });

}
